module.exports = __webpack_public_path__ + "static/media/fuzzbunch.ea89371c.jpg";